import type { RouteObject } from 'react-router-dom';
import SuperAdminRoute from '@components/common/SuperAdminRoute';
import MasterPasswordPage from '@pages/SettingsPage/MasterPasswordPage';

const settingsRoutes: RouteObject[] = [
    {
        path: '/admin/settings/master-password',
        element: (
            <SuperAdminRoute>
                <MasterPasswordPage />
            </SuperAdminRoute>
        ),
    },
];

export default settingsRoutes;
